module.exports = __webpack_public_path__ + "media/images/vr/promo-multijugador-section-bg-23469aa98176dd1a2518d4ccaea7fcfb.jpg";